import { LinkWrap } from '@truphone/gatsby-wrappers'
import React from 'react'
import YesNoBlock from '../components/YesNoBlock'
import '../style.css'

function SupportArticle(props) {
  return (
    <div className="pt-16 bg-grey-100">
      <div className="container mx-auto md:px-6">
        {props.relatedProducts && props.relatedProducts.length > 0 && (
          <p className="py-7 px-3 md:px-0 overflow-x-auto text-sm uppercase md:justify-start font-bold tracking-wider flex items-center whitespace-nowrap">
            <span className="opacity-60 mr-3">{props.relatesToText}:</span>
            {props.relatedProducts && (
              <div className="-mx-1">
                {props.relatedProducts.map((product, i) => (
                  <LinkWrap
                    key={`related-category-${i}`}
                    className={`text-base ${
                      props.dark ? 'bg-blue-900' : 'bg-blue-100'
                    } button-hover text-white font-bold py-1 px-4 rounded-lg mx-1`}
                    href={product.href}
                  >
                    {product.title}
                  </LinkWrap>
                ))}
              </div>
            )}
          </p>
        )}
        <section className="flex flex-col md:flex-row items-start pb-10">
          <div className="bg-white md:grid-9/12 shadow-sm rounded-sm flex-shrink">
            <div className="p-8 border-b border-black border-opacity-10">
              <h1 className="text-2xl" data-swiftype-name="title" data-swiftype-type="string">
                {props.title}
              </h1>
              <h2
                className="text-base mt-1"
                data-swiftype-name="subtitle"
                data-swiftype-type="string"
              >
                {props.subtitle}
              </h2>
              <p
                className={`text-xs mt-4 opacity-60 tracking-wide relative ${
                  props.views ? '' : 'loading-meta'
                }`}
              >
                {props.views && (
                  <>
                    {props.views} {props.viewsText} • {props.publishDate}
                    {' • '}
                    {props.articleType}
                  </>
                )}
              </p>

              <article
                className="text-base mt-8 article-content"
                data-swiftype-name="body"
                data-swiftype-type="text"
                dangerouslySetInnerHTML={{ __html: props.content }}
              />
            </div>
            {props.feedback && props.feedback.enabled && (
              <div className="px-8 border-b border-black border-opacity-10">
                <YesNoBlock {...props.feedback} />
              </div>
            )}
            {props.banner && (
              <div className="px-4 p-8 text-center">
                <h4 className="text-sm font-bold uppercase tracking-wider mb-2">
                  {props.banner.title}
                </h4>
                <div className="flex flex-wrap w-full justify-center">
                  {props.banner.ctas &&
                    props.banner.ctas.map((button, i) => {
                      return (
                        <div className="w-full md:w-auto p-2 md:p-3" key={`cta-${i}`}>
                          <LinkWrap
                            key={`banner-button-${i}`}
                            href={button.href}
                            className={`${
                              i === 0
                                ? 'bg-navy bg-gradient-to-r hover:from-navy hover:to-black text-white w-1/2'
                                : 'bg-blue-100 bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 text-white w-1/2'
                            }  w-full md:w-auto px-4 py-3 inline-block text-center min-w--130 uppercase tracking-wider text-sm font-bold whitespace-nowrap rounded-sm`}
                          >
                            {button.text}
                          </LinkWrap>
                        </div>
                      )
                    })}
                </div>
              </div>
            )}
          </div>
          <div className="px-3 md:px-0 mt-8 md:mt-20 w-full md:grid-1/3 flex-grow sticky top-0">
            <h4 className="px-6 py-2 text-sm uppercase font-bold tracking-wider">
              {props.product}
            </h4>
            {props.questions && (
              <ul className="list-none">
                {props.questions.map((q, i) => {
                  return (
                    <li
                      key={`support-question-${i}`}
                      className={`my-2 text-sm font-bold hover:opacity-100 ${
                        q.selected
                          ? 'bg-white opacity-100 rounded-tr-sm rounded-br-sm'
                          : 'opacity-60'
                      }`}
                    >
                      <LinkWrap href={q.href} className="px-6 py-2 no-underline block">
                        {q.text}
                      </LinkWrap>
                    </li>
                  )
                })}
              </ul>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

export default SupportArticle
